export default __webpack_public_path__ + "static/media/undraw_searching.419ff659.svg";